import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const defaultProps = {
  unit: 'm',
  showMaxOrOver: false,
};

const RangeFilter = (properties) => {
  const props = {
    ...defaultProps,
    ...properties,
  };

  const [value, setValue] = useState(props.max);
  function handleChange(event) {
    props.setState(event.target.value);
    setValue(event.target.value);
  }

  useEffect(() => {
    props.setState(props.max);
  }, []);

  return (
    <div className="range-filter">
      <div>
        <label htmlFor={props.name}>
          {props.label}{' '}
          {props.showMaxOrOver &&
            parseInt(value) === parseInt(props.max) &&
            '>'}
          {value} {props.unit}
        </label>
      </div>
      <input
        type="range"
        id={props.name}
        name={props.name}
        min={props.min}
        max={props.max}
        value={value}
        step={props.step}
        onChange={handleChange}
      />
    </div>
  );
};

RangeFilter.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  step: PropTypes.number,
  setState: PropTypes.func,
  unit: PropTypes.string,
  showMaxOrOver: PropTypes.bool,
};

export default RangeFilter;
